<script setup>
import LoginCustomer from "@/components/LoginCustomer.vue";
import MainHeaders from "@/components/MainHeaders.vue";
import {ref} from 'vue'
import {useRoute} from "vue-router";
import ConfirmEmail from "@/components/ConfirmEmail.vue";

const route = useRoute();
const token = ref(localStorage.getItem("access"));
</script>



<template>
  <v-app>
    <main-headers></main-headers>
    <template v-if="token">
      <v-main class="mx-8 mt-5 pb-11 pr-8" style="background: #F3F9FC;">
        <router-view :key="$route.fullPath"></router-view>
      </v-main>
    </template>
    <template v-else-if="route.query.confirmation_token">
      <confirm-email />
    </template>
    <template v-else>
      <login-customer></login-customer>
    </template>
  </v-app>
</template>


<style>
@import "assets/style.scss";

#app {
  font-family: 'Montserrat', sans-serif;
}
</style>
